// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__uQfa-","bg":"Modal_bg__B7CYK","closeBtn":"Modal_closeBtn__TsnuA","content":"Modal_content__VXhwc"};